export default class ForListAreasInteresseController {
    constructor($state, UIService, AuthenticationService, FormacaoService, FormacaoAreaInteresse, Funcionario, FileUploader) {
        this.$state = $state;
        this.UI = UIService;
        this.FormacaoService = FormacaoService;
        this.FormacaoAreaInteresse = FormacaoAreaInteresse;
        this.Funcionario = Funcionario;
        this.FileUploader = FileUploader;
        this.user = AuthenticationService.getUser();
        this.dataLoaded = false;
        this.simnao = [{ name: "Sim", value: 1 }, { name: "Não", value: 0 }];
        this.funcionarios = [];
        this.filtersLoaded = [1, 0];
        this.opt = $state.params;
        // Default opt state - populate later when we have all states
        this.defaultOpt = {
            page: 1,
            items: 20,
            order: "id",
            sort: "desc",
            filter: undefined
        };
        this.displayColumns = [
            {
                displayName: 'ID SGI',
                name: 'id',
                visible: false,
                sortable: true
            },
            {
                displayName: 'Imagem',
                name: 'imagem',
                visible: true,
                sortable: false
            },
            {
                displayName: 'Designação',
                name: 'designacao',
                visible: true,
                sortable: true
            },
            {
                displayName: 'Data de Edição',
                name: 'dataEdicao',
                exportDate: 'DD-MM-YYYY',
                visible: true,
                sortable: true
            },
            {
                displayName: 'Editado por',
                name: 'colaborador',
                visible: true,
                sortable: true
            },
        ];
        // type 's': select, 'o': plain text, 'd': date
        this.equalityFilters = [{
                val: 'a',
                name: 'Igual',
                type: 'o'
            },
            {
                val: 'b',
                name: 'Diferente',
                type: 'o'
            },
            {
                val: 'c',
                name: 'Começa por',
                type: 'o'
            },
            {
                val: 'd',
                name: 'Termina com',
                type: 'o'
            },
            {
                val: 'e',
                name: 'Contém',
                type: 'o'
            },
            {
                val: 'a',
                name: 'Igual (=)',
                type: 'd'
            },
            {
                val: 'b',
                name: 'Diferente de (≠)',
                type: 'd'
            },
            {
                val: 'c',
                name: 'Posterior a (>)',
                type: 'd'
            },
            {
                val: 'd',
                name: 'Anterior a (<)',
                type: 'd'
            },
            {
                val: 'e',
                name: 'Posterior ou igual (≥)',
                type: 'd'
            },
            {
                val: 'f',
                name: 'Anterior ou igual (≤)',
                type: 'd'
            },
            {
                val: 'a',
                name: 'Igual',
                type: 's'
            },
            {
                val: 'b',
                name: 'Diferente',
                type: 's'
            }
        ];
        this.dateFilters = this.equalityFilters.filter(x => x.type === 'd');
        this.columns = [
            {
                id: 'FormacaoAreaInteresse.id',
                name: 'ID SGI',
                type: 'o'
            },
            {
                id: 'FormacaoAreaInteresse.designacao',
                name: 'Designação',
                type: 'o'
            },
            {
                id: 'FormacaoAreaInteresse.funcionarioId',
                name: 'Editado por',
                type: 's',
                list: this.funcionarios
            },
            {
                id: 'FormacaoAreaInteresse.dataEdicao',
                name: 'Data de Edição',
                type: 'd',
                format: "YYYY-MM-DD",
                displayFormat: "DD/MM/YYYY"
            }
        ];
        // Find relevant displayColumns from local storage
        if (localStorage.getItem('ForAreasInteresseDisplayColumns')) {
            let cols = JSON.parse(localStorage.getItem('ForAreasInteresseDisplayColumns'));
            if (cols && cols.length > 0) {
                cols.forEach(c => {
                    let i = this.displayColumns.findIndex(x => x.name === c.name);
                    if (i >= 0)
                        this.displayColumns[i].visible = c.visible;
                });
            }
        }
        this.customFilters = [];
        // Find customFilters from local storage
        if (localStorage.getItem('ForAreasInteresseFilter')) {
            this.customFilters = JSON.parse(localStorage.getItem('ForAreasInteresseFilter'));
        }
        // Check if something comes from the URL, replace the customFilters if so
        if (this.opt.filter) {
            this.customFilters = [];
            let filters = this.opt.filter.split(":");
            filters.forEach(filter => {
                let a = filter.split("·");
                if (a.length === 3) {
                    try {
                        let data = {
                            column: {},
                            value: {}
                        };
                        data.column.selected = this.columns.find(f => {
                            return f.id === a[0];
                        });
                        if (angular.isUndefined(data.column.selected)) {
                            throw Error();
                        }
                        this.customFilters.push(data);
                    }
                    catch (e) {
                        this.customFilters = [];
                        this.UI.addToast('Não foi possível carregar filtros');
                    }
                }
            });
            // If updated, save it to local storage
            localStorage.setItem('ForAreasInteresseFilter', JSON.stringify(this.customFilters));
        }
        // Restore list to selected if exists
        this.customFilters.forEach(f => {
            if (f.column && f.column.selected) {
                if (f.column.selected.id === 'FormacaoAreaInteresse.funcionarioId')
                    f.column.selected.list = this.funcionarios;
            }
            // Fix date filters to be moment()
            if (f.column.selected.type === 'd') {
                f.value = moment(f.value).utc();
                f.value.second(0); // We don't care about seconds
            }
        });
        // Number of selected items
        this.nSelected = 0;
        // Load the data for the filter panel (not mandatory just to look at the table)
        this.loadData();
        // Load the table data so we can see stuff even if nothing else works
        this.getAreasInteresse();
    }
    clearFilter = () => {
        localStorage.removeItem('ForAreasInteresseFilter');
        this.customFilters = [];
        this.getAreasInteresse();
    };
    // Add entry to whereObject (where/whereLiteral) or to whereOrObject depending if there are multiple selections of the same entry
    setWhereField = (data, whereObject, whereOrObject) => {
        // Check if have this entry in whereOr already
        if (whereOrObject.find(x => x.key === data.key)) { // If so, add it here then
            whereOrObject.push({
                key: data.key,
                value: data.value
            });
        }
        else { // Not in OR, check if there's an entry of this key in whereObject already
            if (whereObject[data.key]) { // Already have an entry for this key, transform it into an OR and add it and the new one
                whereOrObject.push({
                    key: data.key,
                    value: whereObject[data.key]
                });
                delete whereObject[data.key];
                whereOrObject.push({
                    key: data.key,
                    value: data.value
                });
            }
            else { // It's the first entry of this key, use whereObject only
                whereObject[data.key] = data.value;
            }
        }
    };
    // Returns a whereFields object to use in table() remote methods (ativo, interacao)
    // WhereLiteral should be defined locally
    setWhereFields = (customFilters, literal, orsLiteral) => {
        let where = {};
        let whereDates = [];
        let whereNextDates = [];
        let whereLiteral = literal || {};
        let whereOrLiteral = orsLiteral || [];
        let whereOr = [];
        customFilters.forEach(f => {
            let data = {};
            data.key = f.column.selected.id;
            // Generated dates - Assuming if no . exists in field, it's always generated date
            if (f.column.selected.id.split('.').filter(Boolean).length === 1 && f.column.selected.type === 'd') {
                whereNextDates.push({
                    key: data.key,
                    comp: f.values.selected.val,
                    value: f.value,
                    format: f.column.selected.format
                });
            }
            else { // All other cases where fields exist in database
                if (f.column.selected.type === 'o') {
                    data.value = f.value;
                    this.setWhereField(data, where, whereOr);
                }
                else {
                    if (f.column.selected.type === 'd') {
                        whereDates.push({
                            key: data.key,
                            comp: f.values.selected.val,
                            value: f.value,
                            format: f.column.selected.format
                        });
                    }
                    else {
                        // if ID doesn't exist, use value (Yes/No cases where id doesn't exist but value does)
                        if (f.value.selected.id)
                            data.value = f.value.selected.id;
                        else
                            data.value = f.value.selected.value;
                        this.setWhereField(data, whereLiteral, whereOrLiteral);
                    }
                }
            }
        });
        return {
            where: where,
            whereDates: whereDates,
            whereNextDates: whereNextDates,
            whereLiteral: whereLiteral,
            whereOr: whereOr,
            whereOrLiteral: whereOrLiteral
        };
    };
    getAreasInteresse = () => {
        this.tableLoading = true;
        let whereFields = this.setWhereFields(this.customFilters, {
            'FormacaoAreaInteresse.active': 1
        });
        this.FormacaoAreaInteresse.table({
            params: {
                fields: [
                    'FormacaoAreaInteresse.id as id',
                    'FormacaoAreaInteresse.designacao as designacao',
                    'FormacaoAreaInteresse.dataEdicao as dataEdicao',
                    'FormacaoAreaInteresse.imagem as imagem',
                    'Funcionario.name as colaborador',
                ],
                from: ['FormacaoAreaInteresse', 'Funcionario'],
                referencesOrigin: [undefined, undefined],
                references: [undefined, 'FormacaoAreaInteresse.funcionarioId'],
                aliases: [],
                where: whereFields.where,
                whereLiteral: whereFields.whereLiteral,
                whereDates: whereFields.whereDates,
                whereOr: whereFields.whereOr,
                whereOrLiteral: whereFields.whereOrLiteral,
                order: this.opt.order,
                sort: this.opt.sort,
                limit: this.opt.items,
                skip: (this.opt.page - 1) * this.opt.items
            }
        }).$promise.then(res => {
            let page = this.opt.page;
            let items = this.opt.items;
            let total = res.count;
            this.start = total > 0 ? (page - 1) * items + 1 : 0;
            if ((this.start - 1 + items) >= total) {
                this.end = total;
            }
            else {
                this.end = Number.parseInt(this.start - 1 + items);
            }
            this.areasInteresse = res.data;
            this.total = total;
            this.allSelected = false;
            this.tableLoading = false;
        }).catch((error) => {
            this.UI.addToast("Não foi possível ler áreas de interesse. Verifique a ligação");
            console.log(error);
        });
    };
    exportTestemunhos = () => {
        let confirm = this.UI.showConfirm(`Tem a certeza que pretende exportar ${this.total === 1 ? (this.total + ' área') : (this.total + ' áreas')}?`);
        confirm.then(() => {
            let wait = this.UI.showWaiting();
            let whereFields = this.setWhereFields(this.customFilters, { 'FormacaoAreaInteresse.active': 1 });
            this.FormacaoAreaInteresse.exportAreasInteresse({
                displayColumns: this.displayColumns,
                params: {
                    fields: [
                        'FormacaoAreaInteresse.id as id',
                        'FormacaoAreaInteresse.designacao as designacao',
                        'FormacaoAreaInteresse.dataEdicao as dataEdicao',
                        'Funcionario.name as colaborador',
                    ],
                    from: ['FormacaoAreaInteresse', 'Funcionario'],
                    referencesOrigin: [undefined, undefined],
                    references: [undefined, 'FormacaoAreaInteresse.funcionarioId'],
                    aliases: [],
                    where: whereFields.where,
                    whereLiteral: whereFields.whereLiteral,
                    whereDates: whereFields.whereDates,
                    whereOr: whereFields.whereOr,
                    whereOrLiteral: whereFields.whereOrLiteral,
                    order: this.opt.order,
                    sort: this.opt.sort,
                    // limit: this.opt.items,
                    // skip: (this.opt.page - 1) * this.opt.items,
                }
            }).$promise.then(res => {
                if (res.count) {
                    wait.close();
                    let url = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + res.fileData;
                    let b = document.createElement('a');
                    b.href = url;
                    b.download = 'areasExportadas.xlsx';
                    b.click();
                }
                else {
                    this.UI.addToast("Nenhum resultado encontrado. A exportação foi cancelada.");
                }
            }).catch((e) => {
                wait.close();
                console.log(e);
                this.tableLoading = false;
                this.UI.addToast("Não foi possível exportar áreas. Verifique a ligação.");
            });
        }).catch(() => { });
    };
    exportSelected = () => {
        let wait = this.UI.showWaiting();
        let orsLiteral = [];
        // if a few amostras selected only
        if (this.hasSelect())
            orsLiteral = _.map(_.filter(this.areasInteresse, x => x.selected), x => {
                return { key: 'FormacaoAreaInteresse.id', value: x.id };
            });
        let whereFields = this.setWhereFields(this.customFilters, { 'FormacaoAreaInteresse.active': 1 }, orsLiteral);
        this.FormacaoAreaInteresse.exportAreasInteresse({
            displayColumns: this.displayColumns,
            params: {
                fields: [
                    'FormacaoAreaInteresse.id as id',
                    'FormacaoAreaInteresse.designacao as designacao',
                    'FormacaoAreaInteresse.dataEdicao as dataEdicao',
                    'Funcionario.name as colaborador',
                ],
                from: ['FormacaoAreaInteresse', 'Funcionario'],
                referencesOrigin: [undefined, undefined],
                references: [undefined, 'FormacaoAreaInteresse.funcionarioId'],
                aliases: [],
                where: whereFields.where,
                whereLiteral: whereFields.whereLiteral,
                whereDates: whereFields.whereDates,
                whereOr: whereFields.whereOr,
                whereOrLiteral: whereFields.whereOrLiteral,
                order: this.opt.order,
                sort: this.opt.sort,
                // limit: this.opt.items,
                // skip: (this.opt.page - 1) * this.opt.items,
            }
        }).$promise.then(res => {
            if (res.count) {
                wait.close();
                let url = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + res.fileData;
                let b = document.createElement('a');
                b.href = url;
                b.download = 'areasExportadas.xlsx';
                b.click();
            }
            else {
                this.UI.addToast("Nenhum resultado encontrado. A exportação foi cancelada.");
            }
        }).catch((e) => {
            wait.close();
            console.log(e);
            this.tableLoading = false;
            this.UI.addToast("Não foi possível exportar áreas. Verifique a ligação.");
        });
    };
    isColumnVisible = (column) => {
        let f = this.displayColumns.find(x => x.name === column);
        return _.isEmpty(f) ? false : f.visible;
    };
    selectVisibleColumns = () => {
        let options = {
            size: 'md',
            template: require('./columns.dialog.html'),
            controller: ['$dialog', '$scope', (dialog, scope) => {
                    scope.title = "Editar Campos Visíveis";
                    scope.displayColumns = angular.copy(this.displayColumns);
                    scope.ok = () => {
                        dialog.close(scope);
                    };
                    scope.cancel = () => {
                        dialog.dismiss('cancel');
                    };
                }]
        };
        let modal = this.UI.showDialog(options);
        modal.then((res) => {
            if (res && res.displayColumns) {
                this.displayColumns = angular.copy(res.displayColumns);
                // Save it to local storage
                localStorage.setItem('ForAreasInteresseDisplayColumns', JSON.stringify(this.displayColumns));
            }
        });
    };
    loadData = () => {
        this.Funcionario.find({ filter: { where: { active: true }, order: 'name ASC' } }).$promise.then(funcionarios => {
            // funcionarios.forEach(t => {
            //   t.name = t.designacao;
            // });
            funcionarios.sort((a, b) => a.name.localeCompare(b.name));
            this.funcionarios = funcionarios;
            this.filtersLoaded[1] = 1;
        }).catch(err => {
            this.funcionarios = [];
            this.filtersLoaded[1] = 1;
            this.UI.addToast("Erro de carregamento de dados para filtragem (Colaboradores).");
            console.log(err);
        });
    };
    sort = key => {
        if (!key.sortable) {
            return;
        }
        let keyname = key.name;
        if (this.opt.order === keyname)
            this.opt.page = 1;
        this.opt.order = keyname;
        this.opt.sort = this.opt.sort === 'asc' ? 'desc' : 'asc';
        this.$state.go('app.formacao.areasinteresse.list', this.opt, {
            // prevent the events onStart and onSuccess from firing
            notify: false,
            // prevent reload of the current state
            reload: false,
            // replace the last record when changing the params so you don't hit the back button and get old params
            location: 'replace',
            // inherit the current params on the url
            inherit: true
        });
        this.getAreasInteresse();
    };
    item = val => {
        this.opt.items = val;
        this.$state.go('app.formacao.areasinteresse.list', this.opt, {
            // prevent the events onStart and onSuccess from firing
            notify: false,
            // prevent reload of the current state
            reload: false,
            // replace the last record when changing the params so you don't hit the back button and get old params
            location: 'replace',
            // inherit the current params on the url
            inherit: true
        });
        this.getAreasInteresse();
    };
    page = sum => {
        this.opt.page += sum;
        if (this.opt.page < 1)
            this.opt.page = 1;
        if (this.opt.page > Math.ceil(this.total / this.opt.items))
            this.opt.page = Math.ceil(this.total / this.opt.items);
        this.$state.go('app.formacao.areasinteresse.list', this.opt, {
            // prevent the events onStart and onSuccess from firing
            notify: false,
            // prevent reload of the current state
            reload: false,
            // replace the last record when changing the params so you don't hit the back button and get old params
            location: 'replace',
            // inherit the current params on the url
            inherit: true
        });
        this.getAreasInteresse();
    };
    openFilter = () => {
        let result = this.filtersLoaded.reduce((a, b) => a + b, 0);
        if (result !== this.filtersLoaded.length) {
            this.UI.addToast("A carregar dados para filtragem, por favor tente novamente");
            return;
        }
        if (!this.funcionarios.length) {
            this.UI.addToast("Erro ao carregar dados de filtragem. Por favor recarregue a página.");
            return;
        }
        this.columns.forEach(f => {
            if (f.id === 'FormacaoAreaInteresse.funcionarioId')
                f.list = this.funcionarios;
        });
        // Copy column to be used in
        this.editColumns = angular.copy(this.columns);
        // Restore list to selected
        this.customFilters.forEach(f => {
            if (f.column && f.column.selected) {
                if (f.column.selected.id === 'FormacaoAreaInteresse.funcionarioId')
                    f.column.selected.list = this.funcionarios;
            }
        });
        // Copy customFilter to another variable so we can edit it all we want
        this.editCustomFilters = angular.copy(this.customFilters);
        // Show side panel
        this.fs = true;
    };
    oldColumn = ($item, i) => {
        //Infinite Scroll Magic
        i.infiniteScroll = {};
        i.infiniteScroll.numToAdd = 20;
        i.infiniteScroll.currentItems = 20;
        if ($item.type === 's')
            i.value = {};
        else
            i.value = "";
        i.addMoreItems = function () {
            i.infiniteScroll.currentItems += i.infiniteScroll.numToAdd;
        };
    };
    applyFilter = () => {
        // Parse values from sidebar
        this.editCustomFilters = _.filter(this.editCustomFilters, f => f.column && !_.isEmpty(f.value));
        // Remove list for column, no need to save it
        this.editCustomFilters.forEach(f => {
            if (f.column && f.column.selected) {
                f.column.selected.list = [];
            }
            // Fix date filters to be moment()
            if (f.column.selected.type === 'd') {
                f.value = moment(f.value).utc();
                f.value.second(0); // We don't care about seconds
            }
        });
        this.customFilters = angular.copy(this.editCustomFilters);
        localStorage.setItem('ForAreasInteresseFilter', JSON.stringify(this.customFilters));
        this.fs = false;
        // Go to first page for results
        this.opt.page = 1;
        this.$state.go('app.formacao.areasinteresse.list', this.opt, {
            // prevent the events onStart and onSuccess from firing
            notify: false,
            // prevent reload of the current state
            reload: false,
            // replace the last record when changing the params so you don't hit the back button and get old params
            location: 'replace',
            // inherit the current params on the url
            inherit: true
        });
        this.getAreasInteresse();
    };
    hasSelect = () => {
        return _.some(this.areasInteresse, a => a.selected === true);
    };
    selectAll = () => {
        if (this.allSelected) { // Not all are selected, select all
            this.areasInteresse.forEach(a => {
                a.selected = true;
            });
            this.nSelected = this.areasInteresse.length;
        }
        else { // Remove all selections
            this.areasInteresse.forEach(a => {
                a.selected = false;
            });
            this.nSelected = 0;
        }
    };
    selectItem = () => {
        this.nSelected = _.filter(this.areasInteresse, r => r.selected).length;
        this.allSelected = this.nSelected >= this.areasInteresse.length;
    };
    generateUUID = () => {
        let uuid = "", i, random;
        for (i = 0; i < 32; i++) {
            random = Math.random() * 16 | 0;
            if (i == 8 || i == 12 || i == 16 || i == 20) {
                uuid += "-";
            }
            uuid += (i == 12 ? 4 : (i == 16 ? (random & 3 | 8) : random)).toString(16);
        }
        return uuid;
    };
    addAreaInteresse = () => {
        let options = {
            size: 'lg',
            template: require('./images.dialog.html'),
            controller: ['$scope', '$dialog', ($scope, $dialog) => {
                    $scope.images = {};
                    $scope.label = "Adicionar Área de Interesse";
                    $scope.newFileName = '';
                    $scope.oldFileName = '';
                    $scope.designacao = null;
                    $scope.uuid = this.generateUUID();
                    $scope.uploader = new this.FileUploader({
                        url: '/api/Upload/for/upload',
                        queueLimit: 1,
                        formData: [
                            {
                                key: 'value'
                            }
                        ]
                    });
                    let filter = {
                        name: 'verifyIMG',
                        fn: function (item, options) {
                            return item.type.indexOf("image/") !== -1;
                        }
                    };
                    $scope.uploader.filters.push(filter);
                    $scope.uploader.onAfterAddingFile = (item) => {
                        let partes = item.file.name.split(".");
                        $scope.newFileName = $scope.uuid + "." + partes[partes.length - 1];
                        if ($scope.uploader.queue.length > 1)
                            $scope.uploader.queue.splice(0, $scope.uploader.queue.splice.length - 1);
                        $scope.oldFileName = $scope.uploader.queue[0].file.name;
                    };
                    $scope.uploader.onWhenAddingFileFailed = (img) => {
                        this.UI.addToast("Por favor, carregue uma imagem");
                    };
                    $scope.uploader.onErrorItem = (response, status, headers) => {
                        this.UI.addToast("A imagem não foi carregada com sucesso");
                    };
                    $scope.uploader.onBeforeUploadItem = (item) => {
                        item.file.name = $scope.newFileName;
                    };
                    $scope.ok = () => {
                        if ($scope.uploader.queue.length === 0 || $scope.newFileName.length === 0) {
                            this.UI.addToast("Por favor, carregue uma imagem");
                        }
                        else {
                            $dialog.close($scope);
                        }
                    };
                    $scope.cancel = () => {
                        $dialog.dismiss('cancel');
                    };
                }]
        };
        let dialogCreate = this.UI.showDialog(options);
        dialogCreate.then((ok) => {
            if (ok.newFileName.length > 0) {
                let wait = this.UI.showWaiting();
                this.FormacaoAreaInteresse.create({
                    id: 0,
                    designacao: ok.designacao,
                    imagem: ok.newFileName,
                    funcionarioId: this.user.id,
                    dataEdicao: moment().format(),
                    active: 1
                }).$promise.then(() => {
                    wait.close();
                    // File exists, upload it
                    ok.uploader.uploadAll();
                    this.getAreasInteresse();
                    this.UI.addToast("Área de interesse adicionada com sucesso!");
                }).catch(err => {
                    wait.close();
                    this.UI.addToast("Erro a adicionar área de interesse. Verifique a ligação.");
                    console.log(err);
                });
            }
        }).catch((error) => {
            if (error !== 'cancel' && error !== 'escape key press' && error !== 'backdrop click')
                console.log(error);
        });
    };
    editAreaInteresse = (area) => {
        let options = {
            size: 'lg',
            template: require('./images.dialog.html'),
            controller: ['$scope', '$dialog', ($scope, $dialog) => {
                    $scope.images = {};
                    $scope.label = "Adicionar Área de Interesse";
                    $scope.newFileName = '';
                    $scope.oldFileName = '';
                    $scope.designacao = area.designacao;
                    $scope.uuid = this.generateUUID();
                    $scope.uploader = new this.FileUploader({
                        url: '/api/Upload/for/upload',
                        queueLimit: 1,
                        formData: [
                            {
                                key: 'value'
                            }
                        ]
                    });
                    let filter = {
                        name: 'verifyIMG',
                        fn: function (item, options) {
                            return item.type.indexOf("image/") !== -1;
                        }
                    };
                    $scope.uploader.filters.push(filter);
                    $scope.uploader.onAfterAddingFile = (item) => {
                        let partes = item.file.name.split(".");
                        $scope.newFileName = $scope.uuid + "." + partes[partes.length - 1];
                        if ($scope.uploader.queue.length > 1)
                            $scope.uploader.queue.splice(0, $scope.uploader.queue.splice.length - 1);
                        $scope.oldFileName = $scope.uploader.queue[0].file.name;
                    };
                    $scope.uploader.onWhenAddingFileFailed = (img) => {
                        this.UI.addToast("Por favor, carregue uma imagem");
                    };
                    $scope.uploader.onCancelItem = (img) => {
                        $scope.newFileName = '';
                        this.UI.addToast("Cancelled");
                    };
                    $scope.uploader.onErrorItem = (response, status, headers) => {
                        this.UI.addToast("A imagem não foi carregada com sucesso");
                    };
                    $scope.uploader.onBeforeUploadItem = (item) => {
                        item.file.name = $scope.newFileName;
                    };
                    $scope.ok = () => {
                        $dialog.close($scope);
                    };
                    $scope.cancel = () => {
                        $dialog.dismiss('cancel');
                    };
                }]
        };
        let dialogCreate = this.UI.showDialog(options);
        dialogCreate.then((ok) => {
            let wait = this.UI.showWaiting();
            this.FormacaoAreaInteresse.prototype$updateAttributes({ id: area.id }, {
                designacao: ok.designacao,
                imagem: ok.uploader.queue.length > 0 ? ok.newFileName : area.imagem,
                funcionarioId: this.user.id,
                dataEdicao: moment().format(),
                active: 1
            }).$promise.then(() => {
                if (ok.uploader.queue.length > 0) {
                    // File exists, upload it
                    ok.uploader.uploadAll();
                    this.getAreasInteresse();
                }
                else {
                    // No file, just update the list
                    this.getAreasInteresse();
                }
                wait.close();
                this.UI.addToast("Área editada com sucesso!");
            }).catch(err => {
                wait.close();
                this.UI.addToast("Erro a editar área. Verifique ligação.");
                console.log(err);
            });
        }).catch((error) => {
            if (error !== 'cancel' && error !== 'escape key press' && error !== 'backdrop click')
                console.log(error);
        });
    };
    // If id, it's single, if nothing it's multiple and go through "selected"
    confirmRemoveAreaInteresse = (id) => {
        let ids;
        if (id)
            ids = [id];
        else
            ids = this.areasInteresse.map(x => { if (x.selected)
                return x.id; }).filter(x => x);
        if (ids.length === 0)
            return;
        if (ids.length > 20) {
            this.UI.showAlert("Não é possível remover mais de 20 áreas ao mesmo tempo.");
        }
        else {
            let plural = ids.length === 1 ? ` área?` : `s ${ids.length} áreas?`;
            let confirm = this.UI.showConfirm("Tem a certeza que pretende remover esta" + plural);
            confirm.then(() => {
                let wait = this.UI.showWaiting();
                this.FormacaoService.removeAreasInteresse(ids).then(status => {
                    wait.close();
                    let errors = status.filter(x => x.error);
                    if (errors.length > 0) {
                        let title = "Erros de Remoção";
                        let introText = "Ocorreram os seguintes erros na remoção de áreas de interesse:";
                        let instance = this.UI.showDialog({
                            size: 'md',
                            template: require('../../../interface/modals/show-list.html'),
                            controller: ['$scope', ($scope) => {
                                    $scope.title = title;
                                    $scope.introText = introText;
                                    $scope.list = errors;
                                    $scope.ok = function () {
                                        $scope.$close();
                                    };
                                }]
                        });
                        instance.finally(() => {
                            this.getAreasInteresse();
                        });
                    }
                    else {
                        if (ids.length === 1)
                            this.UI.addToast("Área removida com sucesso");
                        else
                            this.UI.addToast("Áreas removidas com sucesso");
                        this.getAreasInteresse();
                    }
                }).catch(error => {
                    wait.close();
                    console.log(error);
                    this.UI.showAlert("Erro na eliminação de áreas. Verifique a ligação");
                });
            });
        }
    };
}
ForListAreasInteresseController.$inject = ['$state', 'UIService', 'AuthenticationService', 'FormacaoService', 'FormacaoAreaInteresse', 'Funcionario', 'FileUploader'];
